import React from 'react';

const SubCategoryFilter = ({ categories, selectedTab, selectedSubCategories = [], onSelect }) => {
  if (!selectedTab) return null;
  const subCategories = categories.filter(c => c.parent_id === selectedTab);
  if (subCategories.length === 0) return null;

  const isAllActive = selectedSubCategories.length === 0;

  return (
    <div className="flex gap-2 overflow-x-auto px-4 pb-2 pt-1" data-testid="subcategory-filter" style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
      {/* "All" pill — default selection */}
      <button
        onClick={() => onSelect([])}
        className={`shrink-0 px-3 py-1 rounded-full text-xs font-medium border transition-colors ${
          isAllActive
            ? 'bg-[var(--theme-primary)] text-white border-[var(--theme-primary)]'
            : 'bg-[var(--theme-surface)] text-[var(--theme-text-muted)] border-[var(--theme-border)] hover:border-[var(--theme-primary)]/40'
        }`}
        data-testid="subcategory-pill-all"
      >
        All
      </button>
      {subCategories.map(sub => {
        const isActive = selectedSubCategories.includes(sub.id);
        return (
          <button
            key={sub.id}
            onClick={() => onSelect(isActive ? [] : [sub.id])}
            className={`shrink-0 px-3 py-1 rounded-full text-xs font-medium border transition-colors ${
              isActive
                ? 'bg-[var(--theme-primary)] text-white border-[var(--theme-primary)]'
                : 'bg-[var(--theme-surface)] text-[var(--theme-text-muted)] border-[var(--theme-border)] hover:border-[var(--theme-primary)]/40'
            }`}
            data-testid={`subcategory-pill-${sub.id}`}
          >
            {sub.image_url && (
              <img src={sub.image_url} alt="" className="w-3.5 h-3.5 rounded-full inline-block mr-1 -ml-0.5" />
            )}
            {sub.name}
          </button>
        );
      })}
    </div>
  );
};

export { SubCategoryFilter };
